if (!customElements.get('bf-privacy-preferences')) {
  customElements.define('bf-privacy-preferences', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      if (!this.button || !this.status) return;
      this.opening = false;
      this.status.hidden = true;
      this.button.disabled = false;
      this.button.removeAttribute('aria-busy');
      this.button.addEventListener('click', () => this.open(), { signal: this.abort.signal });
    }

    async open() {
      if (this.opening) return;
      const { signal } = this.abort;
      this.opening = true;
      this.status.hidden = true;
      this.button.setAttribute('aria-busy', 'true');
      try {
        await this.waitForBanner(signal);
        if (signal.aborted) return;
        // https://shopify.dev/docs/api/customer-privacy#showing-the-preferences-modal
        await window.privacyBanner.showPreferences();
      } catch {
        if (!signal.aborted) this.status.hidden = false;
      } finally {
        if (!signal.aborted) {
          this.opening = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }

    waitForBanner(signal) {
      return new Promise((resolve, reject) => {
        const deadline = Date.now() + 5000;
        let timer;
        const finish = (error) => {
          clearTimeout(timer);
          signal.removeEventListener('abort', cancel);
          error ? reject(error) : resolve();
        };
        const cancel = () => finish(new Error('Privacy preferences unavailable'));
        const check = () => {
          if (signal.aborted) return cancel();
          if (typeof window.privacyBanner?.showPreferences === 'function') return finish();
          if (Date.now() >= deadline || !document.querySelector('script[src*="storefront-banner.js"]')) return cancel();
          timer = setTimeout(check, 100);
        };
        signal.addEventListener('abort', cancel, { once: true });
        check();
      });
    }

    disconnectedCallback() { this.abort?.abort(); }
  });
}
